<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Merchandising from "@/services/Merchandising";
import Http from "@/services/Http";
import Swal from "sweetalert2";
import modalAddProduct from "../../../components/modals/merchandise/modalAddProduct.vue";
import modalEditProduct from "../../../components/modals/merchandise/modalEditProduct.vue";
/**
 * Starter page
 */
export default {
  components: { Layout, PageHeader,modalAddProduct,modalEditProduct },
  page: {
    title: "Products",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Products",
      items: [
        {
          text: "Products",
          href: "/",
        },
      ],
      isCollapsed: true,
      filterData: false,
      isBusy: false,
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      // sortBy: "Art_Sifra",
      sortBy: "date_added",
      sortDesc: true,
      error: null,
      modalData:[],
      categories: [],
      tags: [],
      statistics: {
        total_products: 0,
        with_brand: 0,
        without_brand: 0,
        with_picture: 0,
        without_picture: 0,
        with_category: 0,
        without_category: 0
      },
      statisticsLoading: false,
      cardFilterLoading: false,
      fields: [
        {
          key: "Art_ID",
          label: "Product ID",
        },
        {
          key: "Art_Ime",
          label: "Product Name",
        },
        {
          key: "Art_Proizvoditel",
          label: "Brand",
        },
        {
          key: "Art_Source",
          label: "Source",
        },
        {
          key: "Art_CenaP1",
          label: "Price",
        },
        {
          key: "Art_Active",
          label: "Active",
        },
        "action",
      ],
      filterInput: {
        product_id: '',
        product_name: '',
        category: '0',
        tag: '',
        withpic: '',
        withbrand: '',
      },
    };
  },
  middleware: "authentication",
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
    iconClass() {
      return this.isCollapsed ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down';
    },
    formattedPrice() {
      return (price) => {
        if (!price || typeof price !== 'string') return 'N/A';
        return price.split(".")[0] + ' ден';
      };
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.tableData.length;
  },
  async created() {
    // this.getProducts();
    this.getCategories();
    this.getTags();
    this.getFilters();
    this.getStatistics();
  },
  methods: {

    openModalAddProduct(){
      this.$bvModal.show("add_product");
    },
    openModalEditProduct(data){
      this.modalData = data;
      this.$bvModal.show("edit_product");
    },
    toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    async deleteProduct(id) {
      const status = 0;
      const data = {
        productId: id,
        active: status,
      }
      Swal.fire({
        title: "Delete Product?",
        text: "This Product will be set to not active!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Change!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await Merchandising.changeProductStatus(data);
            if (!response.data.data.error) {
              Swal.fire("Success!", "Product is successfully updated!", "success");
              await  this.getProducts();
            } else {
              let errorMessage = response.data.data.error ? response.data.data.error : 'Failed';
              if (typeof errorMessage === 'object') {
                errorMessage = errorMessage[0];
              }
              Swal.fire("Fail!", errorMessage, "warning");
            }
          } catch (error) {
            let errorMessage = error.response && error.response.data && error.response.data.data.error
                ? error.response.data.data.error
                : "An error occurred while updating the product!";
            if (typeof errorMessage === 'object') {
              errorMessage = errorMessage[0];
            }
            Swal.fire("Error", errorMessage, "error");
          }
        }
      });

    },
    async restoreProduct(id) {
      const status = 1;
      const data = {
        productId: id,
        active: status,
      }
      Swal.fire({
        title: "Restore Product?",
        text: "This Product will be set to  active!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Change!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await Merchandising.changeProductStatus(data);
            if (!response.data.data.error) {
              Swal.fire("Success!", "Product is successfully updated!", "success");
              await this.getProducts();
            } else {
              let errorMessage = response.error ? response.error : 'Failed';
              if (typeof errorMessage === 'object') {
                errorMessage = errorMessage[0];
              }
              Swal.fire("Fail!", errorMessage, "warning");
            }
          } catch (error) {
            let errorMessage = error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : "An error occurred while updating the product!";
            if (typeof errorMessage === 'object') {
              errorMessage = errorMessage[0];
            }
            Swal.fire("Error", errorMessage, "error");
          }
        }
      });

    },

    async getProducts() {
      try {
        this.filterData = true;
        this.isBusy = true;
        this.error = null;
        let filters = this.getFilters();
        // const response = await Merchandising.getProducts(filters);
        const response = await Merchandising.getProductsMerch(filters);

        if (response && response.data && response.data.data && response.data.data.products) {
          this.tableData = Array.isArray(response.data.data.products) ? response.data.data.products : [];
        } else {
          this.tableData = [];
          console.warn('Invalid response structure for products');
        }
        
        this.totalRows = this.tableData.length;
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.error = error.response?.data?.error || "Failed to load products";
        this.tableData = [];
        this.totalRows = 0;
        console.error('Error loading products:', error);
      }
    },
    async getCategories() {
      try {
        const response = await Merchandising.getCategories();
        if (response && response.data && response.data.data) {
          const rawCategories = response.data.data;
          const parsedCategories = [];

          // Support nested response: main categories with subcategories object.
          Object.entries(rawCategories).forEach(([mainKey, mainCategory]) => {
            if (!mainCategory || !mainCategory.name) return;

            parsedCategories.push({
              value: mainCategory.ID_Grupa || mainKey || mainCategory.name,
              label: mainCategory.name,
              level: "main-title",
              isTitle: true,
            });

            const subcategories = mainCategory.subcategories || {};
            Object.entries(subcategories).forEach(([subKey, subCategory]) => {
              if (!subCategory || !subCategory.name) return;

              const subsubcategories = subCategory.subsubcategories || {};

              parsedCategories.push({
                value: subCategory.ID_PodGrupa || subKey || subCategory.name,
                label: subCategory.name,
                parentLabel: mainCategory.name,
                level: "sub",
                isTitle: false,
              });

              // Sub-subcategories are rendered exactly like subcategories and are selectable.
              Object.entries(subsubcategories).forEach(([subsubKey, subsubCategory]) => {
                if (!subsubCategory || !subsubCategory.category_name) return;

                parsedCategories.push({
                  value: subsubCategory.category_id || subsubKey.replace(/"/g, '') || subsubKey,
                  label: subsubCategory.category_name,
                  parentLabel: subCategory.name,
                  level: "subsub",
                  isTitle: false,
                });
              });
            });
          });

          this.categories = parsedCategories;
        } else {
          this.categories = [];
          console.warn('Invalid response structure for categories');
        }
      } catch (error) {
        console.error('Error loading categories:', error);
        this.error = error.response?.data?.error || "Failed to load categories";
        this.categories = [];
      }
    },
    async getTags() {
      try {
        const response = await Merchandising.getTags();
        if (response && response.data && response.data.data) {
          this.tags = response.data.data;
        } else {
          this.tags = [];
          console.warn('Invalid response structure for tags');
        }
      } catch (error) {
        console.error('Error loading tags:', error);
        this.error = error.response?.data?.error || "Failed to load tags";
        this.tags = [];
      }
    },
    getFilters() {
      var filter_string = 'limit=10000&showAll=1';
      filter_string += (this.filterInput.product_id) ? '&id=' + this.filterInput.product_id : "";
      filter_string += (this.filterInput.product_name) ? '&name=' + this.filterInput.product_name : "";
      if (this.filterInput.category && this.filterInput.category !== '0') {
        const categoryValue = this.filterInput.category;
        const looksLikeCategoryId = /^[A-Za-z]+\d+(?:-\d+)*$/.test(categoryValue);
        // Use category_id for values like R01 / R01-02 / R01-02-01, otherwise fallback to category name.
        filter_string += looksLikeCategoryId
          ? '&category_id=' + encodeURIComponent(categoryValue)
          : '&category=' + encodeURIComponent(categoryValue);
      }
      filter_string += (this.filterInput.tag) ? '&tag=' + this.filterInput.tag : "";
      filter_string += (this.filterInput.withpic) ? '&withpic=' + this.filterInput.withpic : "";
      filter_string += (this.filterInput.withbrand) ? '&with_brand=' + this.filterInput.withbrand : "";
      return filter_string;
    },
    async applyFilters() {
      try {
        await Promise.all([this.getProducts(), this.getStatistics()]);
      } catch (error) {
        console.error('Error applying filters:', error);
      }
    },
    async getStatistics() {
      try {
        this.statisticsLoading = true;
        let filters = this.getFilters();
        // const response = await Merchandising.getStatistics(filters);
        const response = await Merchandising.getStatisticsMerch(filters);

        if (response && response.data && response.data.success && response.data.data) {
          this.statistics = response.data.data;
        } else {
          console.warn('Invalid response structure for statistics');
        }
        this.statisticsLoading = false;
      } catch (error) {
        this.statisticsLoading = false;
        console.error('Error loading statistics:', error);
      }
    },
    resetFilters(refreshStatistics = true) {
      this.filterInput = {
        product_id: '',
        product_name: '',
        category: '0',
        tag: '',
        withpic: '',
        withbrand: '',
      };
      this.filterData = false;
      this.tableData = [];
      this.totalRows = 0;
      if (refreshStatistics) {
        this.getStatistics(); // Refresh statistics when filters are reset
      }
    },
      async onCardClick(filterType, filterValue) {
        if (this.cardFilterLoading) {
          return;
        }
        // Show loading state for card-triggered product filtering
        this.cardFilterLoading = true;
      
      try {
        // Reset all filters first (without refreshing statistics)
        this.resetFilters(false);
        
        // Apply the specific filter based on card clicked
        if (filterType === 'withpic') {
          this.filterInput.withpic = filterValue;
        } else if (filterType === 'withbrand') {
          this.filterInput.withbrand = filterValue;
        } else if (filterType === 'all') {
          // For total products card, show all products (no specific filter)
          this.filterInput = {
            product_id: '',
            product_name: '',
            category: '0',
            tag: '',
            withpic: '',
            withbrand: '',
          };
        }
        
        // Apply the filter and refresh both products and statistic cards.
        await Promise.all([this.getProducts(), this.getStatistics()]);
      } catch (error) {
        console.error('Error filtering products:', error);
      } finally {
        // Hide loading state
        this.cardFilterLoading = false;
      }
    },
    formatStatNumber(value) {
      return Number(value || 0).toLocaleString();
    },
    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: `Match added!`,
        showConfirmButton: false,
        timer: 2000,
      });
      this.getProducts();
      this.getCategories();
    },
    async success() {
      this.getProducts();
    },
    failedmsg(msg) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 5000, // Reduced from 50000 (50 seconds is too long)
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- Error Alert -->
    <div v-if="error" class="row mb-4">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          <i class="mdi mdi-alert-circle me-2"></i>
          {{ error }}
        </div>
      </div>
    </div>

  

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <button class="btn btn-success" @click="openModalAddProduct">Add Product</button>
            <div class="row mt-4 d-flex justify-content-center align-items-center">

              <a class="text-body fw-semibold pb-2 d-block" @click="toggleCollapse" data-toggle="collapse"
                 href="javascript: void(0);" role="button" aria-expanded="false" v-b-toggle.collapse>

                <i :class="iconClass" class="accor-down-icon text-primary me-1"></i>Filters
              </a>
              <div class="col-md-8">
                <b-collapse visible id="collapse" class="mt-2">
                  <div class="p-4">
                    <b-form>
                      <!-- First Row: Two inputs and Category select -->
                      <div class="row mb-3">
                        <div class="col-md-4">
                          <b-form-group id="input-group-1" label="Product ID" label-for="input-1">
                            <b-form-input id="input-1" type="text" v-model="filterInput.product_id"></b-form-input>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group id="input-group-2" label="Product Name" label-for="input-2">
                            <b-form-input id="input-2" type="text" v-model="filterInput.product_name"></b-form-input>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group id="input-group-3" label="Category" label-for="input-3">
                            <select v-model="filterInput.category" class="form-control form-select" type="select">
                              <b-form-select-option value='0' disabled>Select a Category</b-form-select-option>
                              <b-form-select-option
                                  v-for="category in categories"
                                  :key="category.value"
                                  :value="category.value"
                                  :disabled="category.isTitle"
                                  :class="{ 'main-category-option': category.isTitle }"
                              >
                                  {{ category.level === 'main-title'
                                    ? category.label.toUpperCase()
                                    : category.level === 'subsub'
                                      ? '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0' + category.label.charAt(0).toUpperCase() + category.label.slice(1).toLowerCase()
                                      : '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0' + category.label.charAt(0).toUpperCase() + category.label.slice(1).toLowerCase() }}
                              </b-form-select-option>
                            </select>
<!--                            <i class="uil uil-angle-down ml-auto mt-2"></i>-->
                          </b-form-group>
                        </div>
                      </div>

                      <!-- Second Row: Three radio button groups -->
                      <div class="row mb-3">
                        <div class="col-md-4">
                          <b-form-group id="input-group-4" label="Has Picture" label-for="input-4">
                            <b-form-radio-group v-slot="{ ariaDescribedby }" v-model="filterInput.withpic">
                              <b-form-radio :aria-describedby="ariaDescribedby" name="pic-radios"
                                            value="Y">Yes</b-form-radio>
                              <b-form-radio :aria-describedby="ariaDescribedby" name="pic-radios" value="N">No</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group id="input-group-6" label="Has Brand" label-for="input-6">
                            <b-form-radio-group v-slot="{ ariaDescribedby }" v-model="filterInput.withbrand">
                              <b-form-radio :aria-describedby="ariaDescribedby" name="brand-radios"
                                            value="Y">Yes</b-form-radio>
                              <b-form-radio :aria-describedby="ariaDescribedby" name="brand-radios" value="N">No</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group id="input-group-5" label="Tag" label-for="input-5">
                            <b-form-radio-group v-slot="{ ariaDescribedby }" v-model="filterInput.tag">
                              <b-form-radio v-for="tag in tags" :key="tag.id" :value="tag.id"
                                            :aria-describedby="ariaDescribedby" name="tag-radios" class="text-capitalize">{{ tag.tag_name
                                }}</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                      </div>

                      <div class="row mt-3">
                        <div class="col d-inline-flex">
                          <button type="button" class="btn btn-success me-2 w-lg" @click="applyFilters">Filter</button>
                          <button type="button" class="btn btn-primary w-lg" @click="resetFilters">Reset</button>
                        </div>
                      </div>
                    </b-form>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
       <!-- Statistics Cards -->
       <div class="row d-flex justify-content-center align-items-center statistics-cards" style="position: relative;">
         <!-- Loading Overlay -->
         <div v-if="statisticsLoading || cardFilterLoading" class="statistics-loading-overlay">
           <div class="d-flex justify-content-center align-items-center h-100">
             <div class="text-center">
               <div class="spinner-border text-primary mb-3" role="status">
                 <span class="visually-hidden">Loading...</span>
               </div>
               <p class="text-muted mb-0">{{ statisticsLoading ? 'Loading statistics...' : 'Loading products...' }}</p>
             </div>
           </div>
         </div>
         
         <div class="col-md-3">
           <div class="card clickable-card" @click="onCardClick('all', '')">
             <div class="card-body">
               <div class="d-flex align-items-center">
                 <div class="flex-shrink-0">
                   <div class="avatar-sm rounded-circle bg-primary bg-gradient">
                     <div class="avatar-title text-white font-size-18">
                       <i class="mdi mdi-package-variant"></i>
                     </div>
                   </div>
                 </div>
                 <div class="flex-grow-1 ms-3">
                   <p class="text-muted mb-1">Total Products</p>
                   <h5 class="mb-0">
                     {{ formatStatNumber(statistics.total_products) }}
                   </h5>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <div class="col-md-3">
           <div class="card clickable-card" @click="onCardClick('withbrand', 'N')">
             <div class="card-body">
               <div class="d-flex align-items-center">
                 <div class="flex-shrink-0">
                   <div class="avatar-sm rounded-circle bg-success bg-gradient">
                     <div class="avatar-title text-white font-size-18">
                       <i class="mdi mdi-tag"></i>
                     </div>
                   </div>
                 </div>
                 <div class="flex-grow-1 ms-3">
                   <p class="text-muted mb-1">Without brand</p>
                   <h5 class="mb-0">
                     {{ formatStatNumber(statistics.without_brand) }}
                   </h5>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <div class="col-md-3">
           <div class="card clickable-card" @click="onCardClick('withpic', 'N')">
             <div class="card-body">
               <div class="d-flex align-items-center">
                 <div class="flex-shrink-0">
                   <div class="avatar-sm rounded-circle bg-info bg-gradient">
                     <div class="avatar-title text-white font-size-18">
                       <i class="mdi mdi-image"></i>
                     </div>
                   </div>
                 </div>
                 <div class="flex-grow-1 ms-3">
                   <p class="text-muted mb-1">Without Picture</p>
                   <h5 class="mb-0">
                     {{ formatStatNumber(statistics.without_picture) }}
                   </h5>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
    <div class="row" v-show="filterData">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4" >
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6" v-show="filterData">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                                  class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <b-table
                :busy="isBusy"
                table-class="table table-centered datatable table-card-list"
                thead-tr-class="bg-transparent"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                show-empty
                empty-text="No Data Found"
                @filtered="onFiltered" >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(Art_CenaP1)="data">
                {{ formattedPrice(data.item.Art_CenaP1) }}
              </template>
              <template #cell(Art_Source)="data">
                <span class="font-size-13" :class="data.item.Art_Source === 'Riversoft' ? 'badge bg-primary' : 'badge bg-danger'">{{ data.item.Art_Source }}</span>
              </template>
              <template v-slot:cell(action)="data">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item">
                    <router-link title="Product Details" :to="{ path: `/merchandising/products/${data.item.Art_Sifra}`}">
                      <i class="uil uil-eye font-size-18"></i>
                    </router-link>
                  </li>
                  <li  class="list-inline-item">
                    <span v-if="data.item.Art_Source !== 'Pantheon'" style="cursor: pointer;" title="Edit Product" @click="openModalEditProduct(data.item)">
                      <i class="uil uil-pen  font-size-18 text-primary"></i>
                    </span>
                  </li>
                  <template v-if="data.item.Art_Source !== 'Pantheon'">
                    <li v-if="data.item.Art_Active === 1" class="list-inline-item">
                    <span style="cursor: pointer;" title="Delete Product" @click="deleteProduct(data.item.Art_ID)">
                      <i class="uil uil-trash-alt text-danger font-size-18"></i>
                    </span>
                    </li>

                    <li v-if="data.item.Art_Active === 0" class="list-inline-item">
                    <span style="cursor: pointer;" title="Restore Product" @click="restoreProduct(data.item.Art_ID)">
                      <i class="fas fa-trash-restore-alt text-danger font-size-15"></i>
                    </span>
                    </li>
                  </template>

                </ul>
              </template>
              <template v-slot:cell(Art_Active)="data">
                <span class="font-size-13" :class="data.item.Art_Active === 1 ? 'badge bg-success' : 'badge bg-danger'">{{ data.item.Art_Active === 1 ? 'Active' : 'Inactive' }}</span>
              </template>

            </b-table>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalAddProduct @onRefresh="getProducts"></modalAddProduct>
    <modalEditProduct @onRefresh="getProducts" :productData="modalData"></modalEditProduct>
  </Layout>
</template>

<style>
.sm {
  width: 1rem;
  height: 1rem;
}

/* Statistics Cards Styling */
.avatar-sm {
  height: 3rem;
  width: 3rem;
}
.custom-control-inline.custom-control-inline.custom-radio {
  margin-right: 2rem !important;
}

.bg-gradient {
  background: linear-gradient(45deg, var(--bs-primary), var(--bs-primary-dark, #0056b3)) !important;
}

.bg-success.bg-gradient {
  background: linear-gradient(45deg, #28a745, #1e7e34) !important;
}

.bg-info.bg-gradient {
  background: linear-gradient(45deg, #17a2b8, #117a8b) !important;
}

/* Statistics Cards Uniform Height and Styling */
.statistics-cards .card {
  height: 100%;
  min-height: 120px;
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.statistics-cards .card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.statistics-cards .card-body {
  padding: 1.5rem;
  display: flex;
  align-items: center;
  height: 100%;
}

.statistics-cards .d-flex {
  width: 100%;
  align-items: center;
}

.statistics-cards .flex-grow-1 {
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.statistics-cards h5 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}

.statistics-cards p {
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0 0 0.5rem 0;
  color: #6c757d;
}

.statistics-cards small {
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

/* Clickable Card Styling */
.clickable-card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.clickable-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
}

.clickable-card:active {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

/* Statistics Loading Overlay */
.statistics-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 1);
  z-index: 10;
  border-radius: 12px;
  min-height: 120px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.statistics-loading-overlay .spinner-border {
  width: 2rem;
  height: 2rem;
}

select.form-select option.main-category-option {
  background-color: #eef2f7;
  font-weight: 600;
}
</style>
